import {useState} from 'react';
import {Box, IconButton, Typography} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {t} from 'i18next';
import CaseContextFieldCard, {CaseContextMode} from './CaseContextFieldCard';
import {
  CaseContextTocSectionConfig,
  getCaseContextSectionAnchorId,
} from './caseContextConfig';
import {CaseContext} from '../../../../../redux/slice/aiReviewSliceV2';

interface CaseContextSectionGroupProps {
  section: CaseContextTocSectionConfig;
  caseContext: CaseContext;
  mode: CaseContextMode;
  onUpdate: (partial: Partial<CaseContext>) => void;
}

const CaseContextSectionGroup = ({
  section,
  caseContext,
  mode,
  onUpdate,
}: CaseContextSectionGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const sectionTitle = t(section.titleKey);
  const fieldsId = `case-context-section-fields-${section.id}`;
  const titleId = `case-context-section-title-${section.id}`;

  return (
    <Box
      id={getCaseContextSectionAnchorId(section.id)}
      className="case-context-section-group"
      data-testid={`case-context-section-${section.id}`}
    >
      <Box
        className="case-context-section-group__header"
        data-testid={`case-context-section-header-${section.id}`}
      >
        <Typography
          component="h3"
          id={titleId}
          className="case-context-section-group__title typo-text subhead3_size"
          data-testid={`case-context-section-title-${section.id}`}
        >
          {sectionTitle}
        </Typography>
        <IconButton
          className="case-context-section-group__toggle"
          aria-label={t(
            isExpanded
              ? 'ai.review.protocolWizard.caseContext.collapseSection'
              : 'ai.review.protocolWizard.caseContext.expandSection',
            {section: sectionTitle}
          )}
          aria-expanded={isExpanded}
          aria-controls={fieldsId}
          data-testid={`case-context-section-toggle-${section.id}`}
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </Box>
      {isExpanded && (
        <Box
          id={fieldsId}
          className="case-context-section-group__fields"
          role="region"
          aria-labelledby={titleId}
        >
          {section.fields.map((fieldConfig) => (
            <CaseContextFieldCard
              key={fieldConfig.key}
              config={fieldConfig}
              caseContext={caseContext}
              mode={mode}
              onUpdate={onUpdate}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CaseContextSectionGroup;
